module.exports = __webpack_public_path__ + "img/037.db7812c6.png";